import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializeAuth } from "../store/slices/authSlice";
import { selectIsAuthenticated } from "../store/selectors/authSelectors";

export const useAuthInit = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Only initialize once per session
    if (!hasInitialized.current) {
      console.log("useAuthInit - dispatching initializeAuth");
      hasInitialized.current = true;
      dispatch(initializeAuth());
    }
  }, [dispatch]);

  // Reset initialization flag when user logs out
  useEffect(() => {
    if (!isAuthenticated) {
      hasInitialized.current = false;
    }
  }, [isAuthenticated]);
};
